import { PaytronixCheckNumberSource } from './paytronix_check_number_source.js';

export function name(source: PaytronixCheckNumberSource): string {
  switch (source) {
    case PaytronixCheckNumberSource.Bite:
      return 'Bite';
    case PaytronixCheckNumberSource.Pos:
      return 'Point of Sale';
  }
}
